var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Breadcrumbs',{attrs:{"main":"Beacon","title":"Case"}}),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"card p-4"},[_c('dataTableVue',{ref:"refDataTable",attrs:{"isSearch":false,"isFilter":true,"isExport":true,"data":{
          module: 'beacon',
          columns: _vm.columns,
          rows: _vm.rows,
          filter_custom: 'filterCustomCase',
          exportDetail: _vm.exportDetail,
        }},on:{"load":_vm.loadItems,"openModal":_vm.openModal}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }